import React from 'react';
import { withFormsy } from 'formsy-react';
import './validators';

class FormsyInput extends React.Component {
  state = {
    isPlaceholder: true
  };

  render = () => {
    //todo: performance enhancements
    const {
      type,
      value,
      name,
      showValid,
      isValid,
      isPristine,
      placeholder,
      errorMessages,
      showError,
      autoComplete,
      className = 'input__group'
    } = this.props;
    const inputProps = {
      type,
      name,
      value,
      autoComplete,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus
    };

    const errors = showError ? errorMessages : '';

    let classes = className;
    classes += isValid || isPristine ? '' : ' error';
    classes += showValid === true && isValid ? ' valid' : '';
    classes +=
      this.state.isPlaceholder && (value === '' || value === undefined)
        ? ''
        : ' label';

    return (
      <div className={classes}>
        <label className="input__label" htmlFor={name}>
          {placeholder}
        </label>
        <div className="input__wrap">
          <input className="input" {...inputProps} />
          {this.renderErrorIcon(classes)}
          {this.renderSuccessIcon(classes)}
        </div>

        <span className="input__error">{errors}</span>
      </div>
    );
  };

  handleChange = e => {
    if ('mask' in this.props) {
      e.target.value = this.props.mask(e.target.value);
    }

    if ('onChange' in this.props) this.props.onChange(e);
    if ('setValue' in this.props)
      this.props.setValue(
        e.currentTarget[this.props.type === 'checkbox' ? 'checked' : 'value']
      );
  };

  handleBlur = e => {
    if ('onBlur' in this.props) this.props.onBlur(e);
    this.setState({ isPlaceholder: true });
  };

  handleFocus = e => {
    if ('onFocus' in this.props) this.props.onFocus(e);
    this.setState({ isPlaceholder: false });
  };

  renderErrorIcon(classes) {
    if (classes.includes('error'))
      return (
        <div className="input-icon-wrap">
          <svg
            className="input-icon input-icon__error"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 13 11"
          >
            <title>Input Error</title>
            <path className="stroke stroke-left" d="M11.53.47,1.47,10.53" />
            <path className="stroke stroke-right" d="M1.5,0.5l10.1,10.1" />
          </svg>
        </div>
      );
  }

  renderSuccessIcon(classes) {
    if (classes.includes('valid'))
      return (
        <div className="input-icon-wrap">
          <svg
            className="input-icon input-icon__success"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 15 10"
          >
            <title>Input Success</title>
            <path className="stroke booger" d="M1.2,5.1l4.2,4.6l8.2-9.2" />
          </svg>
        </div>
      );
  }
}

export default withFormsy(FormsyInput);



// WEBPACK FOOTER //
// ./src/components/form/FormsyInput.js